module.exports = __webpack_public_path__ + "static/ryotei-logo-4d81a28d3770bbd9a33f772c5b646548.png";